import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid } from '@mui/material';

import { AnalyticsMetadataType } from 'graphql/types';
import SuperVisorSourceByTimeChart from '../components/SourceByTimeChart/SuperVisorSourceByTimeChart';
import SupervisorClientChart from '../components/TimeSheetLabelCharts/SupervisorClientChart';
import SupervisorProjectChart from '../components/TimeSheetLabelCharts/SupervisorProjectChart';
import SupervisorUtilizationChart from '../components/MyUtilizationChart/SupervisorUtilizationChart';
import SupervisorTaskChart from '../components/TimeSheetLabelCharts/SupervisorTaskChart';
import OEFChartContextProvider from '../components/TimeSheetLabelCharts/OEFCharts/OEFChartContextProvider';
import OEFSupervisorChartContainer from '../components/TimeSheetLabelCharts/OEFCharts/OEFSupervisorChartContainer';
import TeamTable from '../components/MyTeamChart/TeamTable';
import { useSupervisorInsightContext } from './SupervisorInsightContextProvider';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  itemContainer: {
    width: '43%',
    marginTop: theme.spacing(3)
  },
  itemClassification: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
  },

  rightDiv: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  labelChartDiv: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    justifyContent: 'space-between'
  },
  labelChartGrid: {
    marginTop: theme.spacing(3)
  },
  lowerDiv: {
    display: 'flex'
  }
}));
const SupervisorInsights: React.FC = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.container}>
        <div>
          <div className={classes.itemClassification}>
            <TeamTable />
            <SupervisorUtilizationChart />
          </div>
        </div>
        <div className={classes.lowerDiv}>
          <div className={classes.rightDiv}>
            <Grid container className={classes.labelChartGrid}>
              <Grid item xs={4}>
                <SupervisorClientChart />
              </Grid>
              <Grid item xs={4}>
                <SupervisorProjectChart />
              </Grid>
              <Grid item xs={4}>
                <SupervisorTaskChart />
              </Grid>
              <Grid container>
                <OEFChartContextProvider
                  insightContext={useSupervisorInsightContext}
                  AnalyticsMetadataInput={
                    AnalyticsMetadataType.MetadataSupervisorOefList
                  }
                >
                  <OEFSupervisorChartContainer />
                </OEFChartContextProvider>
              </Grid>
            </Grid>
          </div>

          <div className={classes.itemContainer}>
            <SuperVisorSourceByTimeChart />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(SupervisorInsights);
